package one.healthium.cali

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://cali-content-stage.web.app/"
                Flavour.Prod -> "https://cali-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "CALI",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> ""
            Flavour.Prod -> ""
        },
        adaptyKey = "public_live_BCCeFkxR.4KVD5f9pNr2IutaLcAGC",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6747624701",
        feedbackEmail = "calisthenics@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:940720970302:android:f3ae23149da6fe2d72cf6f",
                apiKey = "AIzaSyC9iXvrXpOVb27USuEpGZMGhvM5kFS4dQ0",
                projectId = "calisthenics-app-stage",
                storageBucket = "calisthenics-app-stage.firebasestorage.app",
                userStorageBucket = "gs://calisthenics-app-stage-users-data",
                authDomain = "calisthenics-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:59109125251:android:1bd1c1fb4399a66d11ffb6",
                apiKey = "AIzaSyCuMI9CeRn9po8T5fgwxYZXuyHQlqYyCKw",
                projectId = "calisthenics-app-prod",
                storageBucket = "calisthenics-app-prod.firebasestorage.app",
                userStorageBucket = "gs://calisthenics-app-prod-users-data",
                authDomain = "calisthenics-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "cali_stage"
            Flavour.Prod -> "cali"
        },
        oneLinkBaseUrl = "https://hltm-cali.onelink.me/dejX/web",
    )

